import NotAccepted from "./NotAccepted";

export default NotAccepted;
